module.exports = __webpack_public_path__ + "static/media/RethinktheInternet.d5f9c6e7.jpg";